

import { enums } from "../enums/"

export const getConsumingAssetFrequency = (consumingAsset) => {
  let frequency = enums.FrequencyTypes.DAILY;
  if(consumingAsset.organization.parentOrganization.matchingType && consumingAsset.organization.parentOrganization.matchingType.frequency ){
    frequency = consumingAsset.organization.parentOrganization.matchingType.frequency;
  }
  return frequency
}


// WEBPACK FOOTER //
// ./src/utils/consumingAssetHelper.js